import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { backgroundsKeys } from './backgroundKeys';
import { IBackgroundResponse } from './useQueryBackgrounds';

export interface IUpdateBackgroundParams {
  id: number;
  fileName?: string;
}

export const updateBackground = async (
  params: IUpdateBackgroundParams
): Promise<IBackgroundResponse> => {
  const { id, ...rest } = params;
  const response = await EXPRESS_API.put(`/backgrounds/${id}`, rest);
  return response.data;
};

export const useUpdateBackgroundMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(updateBackground, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(backgroundsKeys.all());
      onSuccess?.();
      successToast({
        title: `Background has been successfully updated!`,
      });
    },
    onError: error =>
      showError(
        error,
        `An error occurred while trying to update the background!`
      ),
  });
};
